$(document).on('turbolinks:load', function() {
  $('.info-title.js-collapsable').on('click', function(event) {
    $collapsableTitleHeader = $(event.target).parents('.info-title.js-collapsable')
    $collapsableTitleHeader.siblings('.info-table.collapse').collapse('toggle')
    $collapsableTitleHeader.find('h1.text-secondary svg').toggleClass('fa-chevron-right fa-chevron-down')
  })
})
